import { combineReducers } from 'redux'
import * as redukers from 'reduker'
import * as actionTypes from './action-types'

export default combineReducers({
  request: redukers.request({
    start: actionTypes.HOME,
    success: actionTypes.HOME_SUCCESS,
    error: actionTypes.HOME_ERROR,
  }),
  data: redukers.value({
    set: actionTypes.SET_HOME_INFORMATION,
    reset: actionTypes.RESET_HOME_INFORMATION,
  }),
})
